import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { DateField } from "@/components/common";

const F = ({ label, children }) => <div><Label className="text-xs">{label}</Label>{children}</div>;
const Sel = ({ label, value, onChange, testid, disabled, children }) => (
  <F label={label}>
    <Select value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger data-testid={testid}><SelectValue placeholder="Select" /></SelectTrigger>
      <SelectContent>{children}</SelectContent>
    </Select>
  </F>);
const opts = (arr, cap) => arr.map((x) => <SelectItem key={x} value={x} className={cap ? "capitalize" : ""}>{cap ? x.replace(/_/g, " ") : x}</SelectItem>);

export function BasicInfoSection({ f, set, meta, editing }) {
  const depts = meta.workspaces ? meta.workspaces[f.workspace] || meta.departments : meta.departments;
  const pickWs = (v) => { set("workspace", v); const ds = meta.workspaces?.[v] || []; if (!ds.includes(f.department)) set("department", ds[0] || f.department); };
  return (
    <>
      <Sel label="Workspace" value={f.workspace || "office"} onChange={pickWs} testid="otf-workspace" disabled={editing}>
        <SelectItem value="office">Office Work</SelectItem><SelectItem value="factory">Factory &amp; Warehouse</SelectItem>
      </Sel>
      <Sel label="Department" value={f.department} onChange={(v) => set("department", v)} testid="otf-department">{opts(depts)}</Sel>
      <Sel label="Category" value={f.category} onChange={(v) => set("category", v)} testid="otf-category">{opts(meta.categories, true)}</Sel>
      <Sel label="Type" value={f.task_type} onChange={(v) => set("task_type", v)} testid="otf-type" disabled={editing}>{opts(meta.task_types, true)}</Sel>
      <Sel label="Priority" value={f.priority} onChange={(v) => set("priority", v)} testid="otf-priority">{opts(meta.priorities, true)}</Sel>
      <Sel label="Visibility" value={f.visibility} onChange={(v) => set("visibility", v)} testid="otf-visibility">
        <SelectItem value="private">Private (default)</SelectItem>
        <SelectItem value="team">Team (shared members)</SelectItem>
        <SelectItem value="department">Department (managers)</SelectItem>
        <SelectItem value="management">Management only</SelectItem>
      </Sel>
    </>
  );
}

export function AssignmentSection({ f, set, users }) {
  const people = users.map((u) => <SelectItem key={u.user_id} value={u.user_id}>{u.name}</SelectItem>);
  return (
    <>
      <Sel label="Assigned To *" value={f.assigned_to} onChange={(v) => set("assigned_to", v)} testid="otf-assignee">{people}</Sel>
      <Sel label="Reporting Manager" value={f.reporting_manager || "none"} onChange={(v) => set("reporting_manager", v === "none" ? "" : v)} testid="otf-manager">
        <SelectItem value="none">— None —</SelectItem>{people}
      </Sel>
    </>
  );
}

export function ScheduleSection({ f, set, meta, editing }) {
  const effortLabel = (m) => (m < 60 ? `${m} min` : m === 240 ? "Half day" : m === 480 ? "Full day" : `${m / 60}h`);
  return (
    <>
      <DateField label="Start Date" value={f.start_date} onChange={(v) => set("start_date", v)} testId="otf-start-date" />
      <DateField label="Due Date *" value={f.due_date} onChange={(v) => set("due_date", v)} testId="otf-due-date" />
      <F label="Due Time"><Input type="time" value={f.due_time} onChange={(e) => set("due_time", e.target.value)} data-testid="otf-due-time" /></F>
      <Sel label="Estimated effort" value={String(f.estimated_effort_mins || "none")} onChange={(v) => set("estimated_effort_mins", v === "none" ? "" : v)} testid="otf-effort">
        <SelectItem value="none">— Not set —</SelectItem>
        {(meta.effort_options || []).map((m) => <SelectItem key={m} value={String(m)}>{effortLabel(m)}</SelectItem>)}
      </Sel>
      {!editing && (
        <F label="Blocked by (task IDs, comma-separated)"><Input value={f.blocked_by} onChange={(e) => set("blocked_by", e.target.value)} placeholder="OT-00012, OT-00018" data-testid="otf-blocked-by" /></F>)}
    </>
  );
}

export function TemplateSection({ f, setF, templates }) {
  const pick = (v) => {
    const tpl = templates.find((t) => t.template_id === v);
    setF((p) => ({ ...p, template_id: v === "none" ? "" : v, ...(tpl ? { title: tpl.title_format, department: tpl.department, priority: tpl.default_priority || p.priority } : {}) }));
  };
  return (
    <Sel label="Template (optional — prefills title, checklist, subtasks, collaborators)" value={f.template_id || "none"} onChange={pick} testid="otf-template">
      <SelectItem value="none">— No template —</SelectItem>
      {templates.map((t) => <SelectItem key={t.template_id} value={t.template_id}>{t.name}</SelectItem>)}
    </Sel>
  );
}

export function LinksSection({ f, set, projects, showProject }) {
  return (
    <>
      {showProject && (
        <Sel label="Project (optional)" value={f.project_id || "none"} onChange={(v) => set("project_id", v === "none" ? "" : v)} testid="otf-project">
          <SelectItem value="none">— None —</SelectItem>
          {(projects || []).map((p) => <SelectItem key={p.project_id} value={p.project_id}>{p.name}</SelectItem>)}
        </Sel>)}
      <div className="grid grid-cols-2 gap-3">
        <F label="Link: Customer Code"><Input value={f.customer_code} onChange={(e) => set("customer_code", e.target.value)} data-testid="otf-link-customer" placeholder="CUS-00001" /></F>
        <F label="Link: Order / Bill No"><Input value={f.bill_no} onChange={(e) => set("bill_no", e.target.value)} data-testid="otf-link-order" placeholder="SO-2026-00123" /></F>
      </div>
    </>
  );
}
